export default __webpack_public_path__ + "static/media/cow.a82412b4.svg";